import { z } from "zod";
import { add, isBefore, sub } from "date-fns";

import { url } from "utils/regex";

export const createEvent = z
  .object({
    name: z
      .string({ required_error: "Name is required" })
      .trim()
      .max(150, { message: "The maximum allowed length is 150" }),
    description: z
      .string({ required_error: "Description is required" })
      .trim()
      .max(1500, { message: "The maximum allowed length is 1500" }),
    city: z.string({ required_error: "City is required" }).trim(),
    country: z.string({ required_error: "Country is required" }).trim(),
    start_date: z.date({ invalid_type_error: "The date is invalid" }),
    end_date: z.date({ invalid_type_error: "The date is invalid" }),
    expiry_date: z
      .date({ invalid_type_error: "The date is invalid" })
      .min(new Date(), { message: "Date must be in the future" }),
    event_url: z
      .string({ required_error: "Event url is required" })
      .trim()
      .regex(url, {
        message: "It is not valid url",
      }),
    virtual_event: z.boolean(),
    image: z.string({ required_error: "Image is required" }),
    email: z
      .string({ required_error: "Email is required" })
      .trim()
      .email({ message: "It's not a valid e-mail address" }),
    requested_codes: z
      .number()
      .int()
      .min(1, { message: "The number must be greater than 0" }),
    private_event: z.boolean(),
    consent: z
      .boolean()
      .refine((val) => !!val, { message: "Consent is required" }),
  })
  .superRefine((data, ctx) => {
    if (isBefore(data.end_date, data.start_date)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["end_date"],
        message: "End date must be equal or after start date",
      });
    }
    if (
      isBefore(
        data.expiry_date,
        sub(add(data.end_date, { days: 1 }), { seconds: 1 }),
      )
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["expiry_date"],
        message: "Expiry date must be after end date",
      });
    }
  });

export const importEvent = z.object({
  event_id: z.string({ required_error: "Event id is required" }).trim(),
  secret_code: z.string({ required_error: "Secret code is required" }).trim(),
});

export const claim = z.object({
  address: z.string({ required_error: "Address is required" }).trim(),
});

export const reserve = z
  .object({
    link: z.string().trim().optional(),
    links: z.array(z.string().trim()).optional(),
  })
  .superRefine((data, ctx) => {
    if (!data.link && data.links?.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["links"],
        message: "The link is required",
      });
    }
  });
